export class FinancePaymentHistoryDialogModel {
    constructor(
        public distirbutorId: any
    ) {}
}